import { formatUtils } from '@elotech/components';
const { isCpf } = formatUtils;

export const isEmptyObject = (object: object): boolean =>
  !object || Object.keys(object).length === 0;

const extractAttribute = (attributes: any, attributeName: string) =>
  (attributes[attributeName] && attributes[attributeName][0]) || '';

export const createUserObjectFromProfileAndUserExistsData = (
  userProfile: any,
  userProps: any
) => {
  const cpfCnpj = userProps.userName.match(/^(\d{11}|[A-Z0-9]{14})$/i)
    ? userProps.userName
    : '';
  const partialUser = {
    ...userProps,
    cpfCnpj: cpfCnpj,
    nome: userProps.name
  };

  if (isEmptyObject(userProfile.attributes)) {
    return partialUser;
  }

  let tipoPessoaFormatado;
  if (isCpf(cpfCnpj)) {
    tipoPessoaFormatado = 'FISICA';
  }
  if (cpfCnpj.length === 14) {
    tipoPessoaFormatado = 'JURIDICA';
  }

  return {
    cpfCnpj:
      extractAttribute(userProfile.attributes, 'cpfCnpj') ||
      userProfile.username.match(/^(\d{11}|[A-Z0-9]{14})$/i)
        ? userProfile.username
        : partialUser.cpfCnpj || '',
    nome:
      extractAttribute(userProfile.attributes, 'nome') ||
      userProfile.name ||
      partialUser.nome ||
      '',
    nomeFantasia:
      extractAttribute(userProfile.attributes, 'nomeFantasia') || '',
    email:
      extractAttribute(userProfile.attributes, 'email') ||
      partialUser.email ||
      '',
    tipoPessoa:
      extractAttribute(userProfile.attributes, 'tipoPessoa').toUpperCase() ||
      tipoPessoaFormatado,
    telefone:
      extractAttribute(userProfile.attributes, 'celular') ||
      extractAttribute(userProfile.attributes, 'telefone'),
    cep: extractAttribute(userProfile.attributes, 'cep'),
    logradouro: extractAttribute(userProfile.attributes, 'logradouro'),
    numero: extractAttribute(userProfile.attributes, 'numeroEndereco'),
    complemento: extractAttribute(userProfile.attributes, 'complemento'),
    bairro: extractAttribute(userProfile.attributes, 'bairro'),
    cidade: extractAttribute(userProfile.attributes, 'cidade'),
    uf: extractAttribute(userProfile.attributes, 'estado')
  };
};
